import { api } from '@services';
import Equipment, { IEquipment } from '@models/Equipment.model';

export interface IPatchEquipmentsMatch {
  equipmentId: string;
  productId?: string;
  manufacturerId?: string;
  manufacturerName?: string;
  productName?: string;
  model?: string;
  evidenceUrl?: string;
}

const patchEquipmentsMatch = async ({
  equipmentId,
  ...data
}: IPatchEquipmentsMatch): Promise<IEquipment> => {
  const { data: equipment } = await api.patch(
    `/equipments/${equipmentId}/product-match`,
    data,
  );

  return Equipment.fromApiModel(equipment);
};

export { patchEquipmentsMatch };
